module.exports = __webpack_public_path__ + "static/media/part1.4e807ccb.jpg";